// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__36FoB","cell":"ColumnAccessor_cell__1yYji","firstCellAccent":"ColumnAccessor_firstCellAccent__1s-YB"};